class ModalForm {
	constructor(el) {
		this.trigger = el;
		this.htmlEl = document.querySelector('html');
		this.modalEl = document.getElementById(el.getAttribute('data-form-modal'));

		if (!this.modalEl) {
			return;
		}

		if (this.modalEl.parentElement !== document.body) {
			document.body.appendChild(this.modalEl);
		}

		this.closeEl = this.modalEl.querySelector('[data-modal-close]');

		this.bindEvents();
	}

	bindEvents() {
		this.trigger.addEventListener('click', (e) => {
			e.preventDefault();

			this.open();
		});

		if (this.closeEl) {
			this.closeEl.addEventListener('click', (e) => {
				e.preventDefault();

				this.close();
			});
		}

		this.modalEl.addEventListener('click', (e) => {
			if (e.target === this.modalEl) {
				this.close();
			}
		});

		window.addEventListener('keydown', this.escapeListener);
	}

	escapeListener = (e) => {
		if (e.keyCode === 27) {
			this.close();
		}
	};

	isOpen() {
		return this.modalEl.classList.contains('is-open');
	}

	open() {
		this.modalEl.classList.add('is-open');
		this.modalEl.setAttribute('aria-hidden', 'false');
		this.htmlEl.classList.add('modal-active');

		const focusEl = this.modalEl.querySelector('input:not([type="hidden"]), select, textarea');

		if (focusEl) {
			focusEl.focus();
		}
	}

	close() {
		if (!this.isOpen()) {
			return;
		}

		this.modalEl.classList.remove('is-open');
		this.modalEl.setAttribute('aria-hidden', 'true');
		this.htmlEl.classList.remove('modal-active');

		this.trigger.focus();
	}
}

export default ModalForm;
